import copy from "copy-to-clipboard";
import Papa from "papaparse";
import StoreUtils from "./StoreUtils";

class AppUtils {
  static urls = {
    auth: {
      LOGIN: "auth/login",
      TIMESLOT_LOGIN: "/login",
      START_ENROLLMENT: "/signup",
      END_ENROLLMENT: "/complete-Signup",
      RESEND_OTP: "/authentication/resend-otp",
      INITIATE_RESET: "/authentication/init-password-reset",
      COMPLETE_RESET: "/authentication/complete-password-reset",
      CHANGE_PASSWORD: "/authentication/change-password",
      USER_DETAILS: "/user-details",
      GOOGLE_SIGNUP: "/google-signup",
      ADD_EDUCATION: "applicant/add-education-details",
      ADD_PROJECTS: "applicant/add-project",
      ADD_EMPLOYMENT: "applicant/add-employment-details",
      ADD_APPLICANT_DETAILS: "applicant/create-applicant-details",
      CREATE_RECRUITER: "recruiter/create-recruiter",
      CONFIRM_RECRUITER_OTP: "recruiter/confirm-recruiter-otp",
      ADD_ORGANIZATION: "recruiter/create-recruiter-details",
      RECRUITER_ADD_PROJECT: "recruiter/create-project",
      CREATE_APPLICANT: "applicant/create-applicant",
      CONFIRM_OTP: "applicant/confirm-applicant-otp",
      FORGOT_PASSWORD: "auth/forgot-password",
      CONFIRM_FORGOT_PASSWORD_OTP: "auth/reset-password-with-otp",
      POST_JOB: "recruiter/create-job",
      REFRESH_APPLICANT: "auth/details",
      SEE_TALENTS: "recruiter/see-talents",
      EDIT_APPLICANT: "applicant/edit-applicant",
      FETCH_DEGREES: "applicant/degrees"
    },
    project: {
      UPDATE_PROJECT: "applicant/update-project",
      DELETE_PROJECT: "applicant/delete-project"
    },
    campaign: {
      FETCH_ACTIVE_CAMPAIGNS: "/readActiveCampaign",
      FETCH_SINGLE_CAMPAIGN: "/readSingleCampaign"
    },
    applicant: {
      FETCH_APPLICANT_DETAILS: "/applicant/get-applicant-by-id",
      ADD_EMPLOYMENT: "applicant/add-employment-details",
      ADD_PROJECT: "applicant/add-project",
      EDIT_PROJECT: "applicant/update-project",
      DELETE_PROJECT: "applicant/delete-project",
      EDIT_EMPLOYMENT: "applicant/update-employment-details",
      DELETE_EMPLOYMENT: "applicant/delete-employment-detail",
      FETCH_EMPLOYMENT_HISTORY: "applicant/get-applicant-employments",
      EDIT_EDUCATION: "applicant/update-education-details",
      FETCH_EDUCATION_HISTORY: "applicant/get-applicant-educations",
      FETCH_PROJECT_HISTORY: "applicant/get-applicant-projects",
      ADD_EDUCATION: "applicant/add-education-details",
      FETCH_ROLES_AND_SKILLS: "applicant/role-skills",
      FETCH_INDUSTRIES: "applicant/industries",
      EDIT_PORTFOLIO: "applicant/edit-portfolio",
      FETCH_PORTFOLIO: "applicant/get-applicant-by-id",
      FETCH_PORTFOLIO_LINKS: "config/profile-links",
      VIEW_JOB: "applicant/view-job",
      FETCH_ALL_JOBS: "recruiter/get-all-jobs",
      FETCH_APPLIED_JOBS: "recruiter/get-jobs-by-applicant",
      APPLY_JOB: "applicant/apply",
      ACCEPT_INTERVIEW: "interview/update-interview",
      DECLINE_INTERVIEW: "interview/update-interview",
      FETCH_APPLICANT_INTERVIEWS: "interview/get-applicant-interviews",
      RESCHEDULE_INTERVIEW: "interview/reschedule-interview",
      FETCH_JOB_INTERVIEWS: "interview/get-job-interviews",
      FETCH_ALL_APPLICANTS: "applicant/get-all-applicants"
    },
    recruiter: {
      EDIT_COMPANY: "recruiter/update-recruiter-details",
      ADD_COMPANY: "recruiter/create-recruiter-details",
      FETCH_JOBS: "recruiter/get-jobs-by-recruiter",
      FETCH_SINGLE_JOB: "recruiter/get-single-job",
      UPDATE_JOB: "recruiter/update-job",
      UPDATE_JOB_STATUS: "recruiter/update-job-status",
      FETCH_JOB_APPLICANTS: "applicant/get-applicants-by-job",
      FETCH_JOB_APPLICANT: "applicant/get-applicant-by-id",
      FETCH_JOB_INTERVIEWS: "interview/get-job-interviews",
      INVITE_TO_INTERVIEW: "recruiter/schedule-interview",
      VIEW_OFFER: "applicant/get-applicant-offers",
      MAKE_OFFER: "recruiter/make-offer",
      FETCH_OFFERS: "applicant/get-recruiter-offers",
      EDIT_JOB_POST: "recruiter/update-job"
    },
    customer: {
      CREATE_CUSTOMER: "/customer/create",
      READ_CUSTOMER: "/customer/read",
      UPDATE_CUSTOMER: "/customer/update",
      READ_BY_CUSTOMER: "/customer/read-by-customer-id",
      READ_TIMEZONES: "/customer/read-timezones",
      UPLOAD_IMAGE: "/customer/upload-image"
    },
    professional: {
      CREATE_PROFESSIONAL: "/professional/create",
      READ_PROFESSIONAL: "/professional/read",
      UPDATE_PROFESSIONAL: "/professional/update",
      READ_BY_PROFESSIONAL: "/professional/read-by-professional-id",
      FETCH_CATEGORY: "/professional/category/read",
      FETCH_EXPERIENCE_LEVEL: "/professional/experience-level/read",
      SEARCH_PROFESSIONAL: "/professional/search",
      READ_SUBSCRIPTION_PLANS:
        "/professional/read-subscription-by-professional-id",
      UPDATE_SUBSCRIPTION_PLANS: "/professional/update-subscription-plan",
      READ_BY_REFERENCE: "/user",
      READ_REVIEWS: "/professional/read-reviews"
    },
    booking: {
      CREATE_BOOKING: "/booking/create",
      READ_BOOKING: "/booking/read",
      UPDATE_BOOKING: "/booking/update",
      READ_BY_BOOKING_ID: "/booking/read-by-booking-id",
      READ_BY_CUSTOMER_ID: "/booking/read-by-customer-id",
      READ_BY_PROFESSIONAL_ID: "/booking/read-by-professional-id",
      CANCEL_BOOKING: "/booking/cancel",
      RESCHEDULE_BOOKING: "/booking/reschedule",
      READ_PENDING_REVIEWS: "/booking/read-pending-reviews",
      UPDATE_REVIEW: "/booking/update-review"
    },
    wallet: {
      BALANCE_ENQUIRY: "/wallet/balance-enquiry",
      RECENT_TRANSACTIONS: "/wallet/history",
      CREATE_PAYMENT_INTENT: "/create-payment-intent",
      READ_WALLET: "/wallet/read"
    },
    availability: {
      CREATE_AVAILABLE_TIME_GROUP: "/available-time-group/create",
      READ_AVAILABLE_TIME_GROUP: "/available-time-group/read",
      UPDATE_AVAILABLE_TIME_GROUP: "/available-time-group/update",
      DELETE_AVAILABLE_TIME_GROUP: "/available-time-group/delete",
      READ_BY_AVAILABLE_TIME_GROUP_ID:
        "/available-time/read-by-available-time-group-id",
      READ_BY_PROFESSIONAL_ID: "/available-time-group/read-by-professional-id",
      READ_COUNT: "/available-time/read-count",
      READ_DATES: "/available-time/read-dates",
      READ_BY_DATE: "/available-time/read-by-date",
      READ_NEXT_DAYS: "/available-time/read-next-days",
      READ_AVAILABLE_SUBSCRIPTION_TIME:
        "/available-time/read-available-subscription-time"
    },
    messageRequest: {
      CREATE_MESSAGE_REQUEST: "/message-request/create",
      READ_MESSAGE_REQUEST: "/message-request/read",
      UPDATE_MESSAGE_REQUEST: "/message-request/update",
      ACCEPT_MESSAGE_REQUEST: "/message-request/accept",
      DECLINE_MESSAGE_REQUEST: "/message-request/decline",
      READ_BY_MESSAGE_REQUEST: "/message-request/read-by-message-request-id",
      READ_PENDING_MESSAGE_REQUEST: "/message-request/read-pending-requests"
    },
    subscription: {
      CREATE_SUBSCRIPTION: "/subscription/create",
      APPROVE_SUBSCRIPTION: "/subscription/approve",
      DECLINE_SUBSCRIPTION: "/subscription/decline",
      READ_BY_PROFESSIONAL: "/subscription/read-by-professional-id",
      READ_BY_CUSTOMER: "/subscription/read-by-customer-id"
    },
    messageGroup: {
      CREATE_MESSAGE_GROUP: "/message-group/create",
      READ_MESSAGE_GROUP: "/message-group/read",
      UPDATE_MESSAGE_GROUP: "/message-group/update",
      READ_BY_MESSAGE_GROUP_ID: "/message-group/read-by-message-group-id"
    },
    payOutAccount: {
      CREATE_PAY_OUT_ACCOUNT: "/pay-out-account/create",
      UPDATE_PAY_OUT_ACCOUNT: "/pay-out-account/update",
      READ_PAY_OUT_ACCOUNT: "/pay-out-account/read",
      READ_BY_PAY_OUT_ACCOUNT_ID: "/pay-out-account/read-by-pay-out-account-id",
      CREATE_STRIPE_PAY_OUT_ACCOUNT: "/pay-out-account/create-stripe",
      GET_COUNTRIES: "/get-countries",
      FLUTTERWAVE_FUNDING: "/flutterwave-funding",
      FLUTTERWAVE_VERIFY: "/flutterwave-verify"
    },
    message: {
      CREATE_MESSAGE: "/message/create",
      READ_MESSAGE: "/message/read",
      UPDATE_MESSAGE: "/message/update",
      READ_BY_MESSAGE_ID: "/message/read-by-message-id",
      READ_BY_CUSTOMER_ID: "/message/read-by-customer-id",
      READ_MESSAGE_BY_MESSAGE_GROUP_ID: "/message/read-by-message-group-id"
    },
    notification: {
      READ_NOTIFICATIONS: "/notification/read-by-notification-recipient",
      UPDATE_STATUS: "/notification/update-status"
    },
    groupSession: {
      CREATE_GROUP_SESSION: "/group-session/create",
      ENROLL_GROUP_SESSION: "/group-session/enroll",
      READ_GROUP_SESSION: "/group-session/read",
      READ_BY_GROUP_SESSION_ID: "/group-session/read-by-group-session-id",
      READ_BY_CUSTOMER_ID: "/group-session/read-by-customer-id",
      READ_BY_PROFESSIONAL_ID: "/group-session/read-by-professional-id",
      READ_ENROLLED_CUSTOMERS: "/group-session/read-enrolled-by-gs-id",
      READ_ALL_GROUP_SESSIONS_PER_USER: "/group-session/read-all"
    },
    payOut: {
      CREATE_PAY_OUT: "/pay-out/create"
    }
  };

  static parameters = {
    user: {}
  };

  static getDefaultPayload = {
    source: "web"
  };

  static convertCsvToJson(files, doneAction = () => {}) {
    if (!files.length) {
      StoreUtils.dispatch(
        StoreUtils.actions.notification.addNotificationSlide,
        {
          type: "error",
          message: `Please select a file!`
        }
      );
      return { responseCode: "01", responseMessage: `Please select a file` };
    } else {
      let csvFile = files[0];
      if (csvFile.name.includes("csv")) {
        Papa.parse(csvFile, {
          complete: function(results) {
            let csvArrayOfArrays = results.data;
            let arrayOfKeys = csvArrayOfArrays[0];

            let mapArrayToObject = (arrayOfValues, arrayOfKeys) => {
              let resultObject = {};
              arrayOfKeys.forEach(function(value, i) {
                resultObject[value] = arrayOfValues[i];
              });
              return resultObject;
            };

            let csvJson = csvArrayOfArrays
              .map((currentArray, index) => {
                if (index !== 0) {
                  return mapArrayToObject(currentArray, arrayOfKeys);
                }
                return null;
              })
              .filter((element, index) => {
                if (index !== 0) {
                  return element;
                }
              });

            doneAction(csvJson);
          }
        });
        return { responseCode: "00", responseMessage: "Success" };
      } else {
        StoreUtils.dispatch(
          StoreUtils.actions.notification.addNotificationSlide,
          {
            type: "error",
            message: `Please select a CSV file!`
          }
        );
        return {
          responseCode: "01",
          responseMessage: "Please select a CSV file"
        };
      }
    }
  }

  static getDeviceId() {
    let module = {
      options: [],
      header: [
        navigator.platform,
        navigator.userAgent,
        navigator.appVersion,
        navigator.vendor,
        window.opera
      ],
      dataos: [
        { name: "Windows Phone", value: "Windows Phone", version: "OS" },
        { name: "Windows", value: "Win", version: "NT" },
        { name: "iPhone", value: "iPhone", version: "OS" },
        { name: "iPad", value: "iPad", version: "OS" },
        { name: "Kindle", value: "Silk", version: "Silk" },
        { name: "Android", value: "Android", version: "Android" },
        { name: "PlayBook", value: "PlayBook", version: "OS" },
        { name: "BlackBerry", value: "BlackBerry", version: "/" },
        { name: "Macintosh", value: "Mac", version: "OS X" },
        { name: "Linux", value: "Linux", version: "rv" },
        { name: "Palm", value: "Palm", version: "PalmOS" }
      ],
      databrowser: [
        { name: "Chrome", value: "Chrome", version: "Chrome" },
        { name: "Firefox", value: "Firefox", version: "Firefox" },
        { name: "Safari", value: "Safari", version: "Version" },
        { name: "Internet Explorer", value: "MSIE", version: "MSIE" },
        { name: "Opera", value: "Opera", version: "Opera" },
        { name: "BlackBerry", value: "CLDC", version: "CLDC" },
        { name: "Mozilla", value: "Mozilla", version: "Mozilla" }
      ],
      init: function() {
        let agent = this.header.join(" "),
          os = this.matchItem(agent, this.dataos),
          browser = this.matchItem(agent, this.databrowser);

        return { os: os, browser: browser };
      },
      matchItem: (string, data) => {
        // let i = 0,
        let j = 0,
          i,
          regex,
          regexv,
          match,
          matches,
          version;

        for (i = 0; i < data.length; i += 1) {
          regex = new RegExp(data[i].value, "i");
          match = regex.test(string);
          if (match) {
            regexv = new RegExp(data[i].version + "[- /:;]([\\d._]+)", "i");
            matches = string.match(regexv);
            version = "";
            if (matches) {
              if (matches[1]) {
                matches = matches[1];
              }
            }
            if (matches) {
              matches = matches.split(/[._]+/);
              for (j = 0; j < matches.length; j += 1) {
                if (j === 0) {
                  version += matches[j] + ".";
                } else {
                  version += matches[j];
                }
              }
            } else {
              version = "0";
            }
            return {
              name: data[i].name,
              version: parseFloat(version)
            };
          }
        }
        return { name: "unknown", version: 0 };
      }
    };

    let e = module.init();

    let device = {
      os: e.os.name,
      osVersion: e.os.version,
      browser: e.os.browser.name,
      browserVersion: e.browser.version,
      userAgent: navigator.userAgent,
      appVersion: navigator.appVersion,
      platform: navigator.platform,
      vendor: navigator.vendor
    };

    return `${device.os}-${device.appVersion}`;
  }

  static getPushId() {
    return "0";
  }

  static copyToClipBoard(textToCopy) {
    copy(textToCopy);

    const notification = {
      type: "success",
      message: `Copied!`
    };
    StoreUtils.dispatch(
      StoreUtils.actions.notification.addNotificationSlide,
      notification
    );
  }

  static getCurrencyColorCode(currency) {
    switch (currency) {
      case "BTC":
        return `#f19617`;
      case "ETH":
        return `#0e367a`;
      case "NGN":
        return `#126152`;
      default:
        return `#505050`;
    }
  }

  static allCountriesArray() {
    return [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antigua &amp; Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia &amp; Herzegovina",
      "Botswana",
      "Brazil",
      "British Virgin Islands",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Cape Verde",
      "Cayman Islands",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Congo",
      "Cook Islands",
      "Costa Rica",
      "Cote D Ivoire",
      "Croatia",
      "Cruise Ship",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "French West Indies",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kuwait",
      "Kyrgyz Republic",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macau",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Namibia",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Norway",
      "Oman",
      "Pakistan",
      "Palestine",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Pierre &amp; Miquelon",
      "Samoa",
      "San Marino",
      "Satellite",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "South Africa",
      "South Korea",
      "Spain",
      "Sri Lanka",
      "St Kitts &amp; Nevis",
      "St Lucia",
      "St Vincent",
      "St. Lucia",
      "Sudan",
      "Suriname",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Timor L'Este",
      "Togo",
      "Tonga",
      "Trinidad &amp; Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks &amp; Caicos",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "Uruguay",
      "Uzbekistan",
      "Venezuela",
      "Vietnam",
      "Virgin Islands (US)",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ];
  }
}

export default AppUtils;
